











































































































import PageHeader from '@/components/PageHeader.vue'
import {Component, Vue, Prop, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import {showChannelTalk} from '@/utils'

import {certGuideProcess} from './constants/certGuideProcess'
import Timer from './setting/TimerComponent.vue'

const certificates = namespace('certificates')
const userAgent = namespace('userAgent')

@Component({
  components: {PageHeader, Timer}
})
export default class RegisterCertGuidePopup extends Vue {
  @certificates.Action('getRegisterCode') getRegisterCode

  @Prop({default: false}) open: boolean

  @userAgent.Getter('isMobile') isMobile: boolean

  certGuideProcess = certGuideProcess
  loading: boolean = true
  code: string = '-----'
  errorMsg: string = ''

  @Watch('open', {immediate: true})
  __open(value) {
    if(value) {
      this.requestCode()
    } else {
      this.initCode()
    }
  }

  initCode() {
    this.code = '-----'
    this.errorMsg = ''
  }

  requestCode() {
    this.getRegisterCode({services: []})
      .then((data) => {
        this.loading = false
        this.code = data
        this.errorMsg = ''
        if(!this.isMobile) {
          const targetUrl = process.env.NODE_ENV !== 'production' ? 'https://sole-app.stag-a.overtax.co.kr' : 'https://app.sole.overtax.co.kr'
          window.open(`${targetUrl}/cert-corp?auth_code=${this.code}`, '_blank')
        }
      })
      .catch(() => {
        this.errorMsg = '발급 실패'
      })
  }

  handleTimeUp() {
    this.errorMsg = '유효시간 초과'
  }

  openChannelTalk() {
    showChannelTalk()
  }
}
